interface MessagesIconProps {
  unreadCount: number
  onClick?: () => void
  className?: string
  href?: string
  tooltipLabel?: string
  isActive?: boolean
  activeClass?: string
}

export function MessagesIcon({
  unreadCount,
  onClick,
  className = '',
  href,
  tooltipLabel,
  isActive = false,
  activeClass = 'bg-slate-200/80 dark:bg-slate-700 text-slate-800 dark:text-slate-100',
}: MessagesIconProps) {
  const displayCount = unreadCount > 9 ? '9+' : String(unreadCount)

  const inner = (
    <>
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute top-1 right-1 min-w-[16px] h-4 px-0.5 flex items-center justify-center rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold leading-none">
          {displayCount}
        </span>
      )}
    </>
  )

  const tooltip = tooltipLabel ? (
    <span
      aria-hidden
      className="
        absolute start-full ms-3 top-1/2 -translate-y-1/2
        px-3 py-2 rounded-lg z-50
        bg-slate-800 dark:bg-sand-100
        opacity-0 group-hover:opacity-100
        pointer-events-none transition-opacity duration-150 shadow-sm
        text-sm font-medium text-white dark:text-slate-800 font-sans leading-tight whitespace-nowrap
      "
    >
      {tooltipLabel}
    </span>
  ) : null

  const baseClass = [
    'relative p-2 rounded-md transition-colors',
    isActive
      ? activeClass
      : 'text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800/60',
    className,
  ].filter(Boolean).join(' ')

  if (href) {
    return (
      <span className="group relative inline-flex">
        <a
          href={href}
          aria-label={`Messages${unreadCount > 0 ? `, ${unreadCount} unread` : ''}`}
          className={baseClass}
        >
          {inner}
        </a>
        {tooltip}
      </span>
    )
  }

  return (
    <span className="group relative inline-flex">
      <button
        type="button"
        aria-label={`Messages${unreadCount > 0 ? `, ${unreadCount} unread` : ''}`}
        onClick={onClick}
        className={baseClass}
      >
        {inner}
      </button>
      {tooltip}
    </span>
  )
}
